<div class="lps-grid" [class.mirrored]="isMirrored()">
  @for (row of rows(); track $index) {
    <div class="lps-row" [class.mirrored]="isMirrored()">
      @for (block of row; track block.displayConfig.key) {
        <hd-planet-activation-block
          [activation]="block.activation"
          [displayConfig]="block.displayConfig"
          [colorConfig]="colorConfig()"
          [isDefined]="block.isDefined"
          [geneKeysLabel]="block.geneKeysLabel"
          [showHdKeynotes]="showHdKeynotes()"
          [matchLines]="matchLines()"
          [profileLines]="profileLines()"
          [density]="density()"
          variant="grid"
          (blockClicked)="blockClicked.emit($event)"
        ></hd-planet-activation-block>
      }
    </div>
  }
</div>
